var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "room-item",
      class: [{ selected: _vm.isSelected }],
      attrs: { "data-component": "booking-room-item" },
    },
    [
      _vm.numberOfUnits < 5 && !_vm.isSelected
        ? _c("div", { staticClass: "room-ribbon" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.tc("booking.roomsLeft", {
                    numberOfUnits: _vm.numberOfUnits,
                  })
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "room-image" },
        [
          _vm.isSelected
            ? _c("div", { staticClass: "current-selected" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.tc("booking.currentSelection")) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "carousel",
            {
              key: "carousel-" + _vm.room.synXisID,
              attrs: { selector: ".carousel-wrapper", variant: "show1" },
            },
            [
              _c("section", { staticClass: "carousel media-only" }, [
                _c(
                  "div",
                  { staticClass: "carousel-wrapper show1" },
                  _vm._l(_vm.room.images, function (item, i) {
                    return _c(
                      "div",
                      {
                        key: i + "-" + item.src + "-image-" + _vm.room.synXisID,
                        staticClass: "slide",
                      },
                      [
                        _c("div", { staticClass: "slide-image" }, [
                          _c(
                            "picture",
                            {
                              directives: [
                                {
                                  name: "lazyload",
                                  rawName: "v-lazyload",
                                  value: {
                                    src: item.src,
                                    set: [
                                      {
                                        width: "800",
                                        height: "450",
                                        breakpoint: "xs",
                                      },
                                      {
                                        width: "800",
                                        height: "450",
                                        breakpoint: "md",
                                      },
                                    ],
                                    fit: "crop",
                                    align: "center",
                                  },
                                  expression:
                                    "{\n                  src: item.src,\n                  set: [\n                    { width: '800', height: '450', breakpoint: 'xs' },\n                    { width: '800', height: '450', breakpoint: 'md' }\n                  ],\n                  fit: 'crop',\n                  align: 'center'\n                }",
                                },
                              ],
                              key:
                                i +
                                "-" +
                                item.src +
                                "-image-" +
                                _vm.room.synXisID +
                                "-picture",
                              staticClass: "image-wrapper",
                            },
                            [
                              _c("img", {
                                staticClass: "image",
                                attrs: {
                                  src: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==",
                                  alt: item.alt,
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "room-content-wrapper" },
        [
          _c("div", { staticClass: "room-content" }, [
            _c("div", { staticClass: "room-title" }, [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.room.title)),
              ]),
              _vm._v(" "),
              _vm.room.roomPageUrl
                ? _c("div", { staticClass: "room-view-more" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: _vm.room.roomPageUrl, target: "_blank" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.tc("booking.seeDetails")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "room-details" }, [
              _c("div", { staticClass: "room-metrics" }, [
                _vm.room.squareMeters
                  ? _c("span", { staticClass: "square-meters" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.room.squareMeters) +
                          " " +
                          _vm._s(_vm.tc("booking.squareMeters")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.room.squareFeet
                  ? _c("div", { staticClass: "marker" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.room.squareFeet
                  ? _c("span", { staticClass: "square-feet" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.room.squareFeet) +
                          " " +
                          _vm._s(_vm.tc("booking.squareFeet")) +
                          "\n          "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "room-info" }, [
              _vm.room.shortDescription
                ? _c("div", { staticClass: "room-description" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.shortDescription) +
                        "\n        "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("form", { staticClass: "mohg-form select-bed" }, [
                _c("fieldset", [
                  _c("legend", { staticClass: "sr-only" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.tc("booking.selectBed")) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input dropdown" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedBed,
                            expression: "selectedBed",
                          },
                        ],
                        attrs: {
                          id: "select-bed-type-" + _vm.room.synXisID,
                          "data-field-type": "DropdownList",
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedBed = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.bedTypes, function (bed, i) {
                        return _c(
                          "option",
                          {
                            key: bed.synXisID + "-" + bed.title + "-bed",
                            domProps: { value: i },
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(bed.title) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "floating",
                        attrs: { for: "select-bed-type-" + _vm.room.synXisID },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.tc("booking.selectBed")) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("rate-list", {
            attrs: { room: _vm.room, "bed-type": _vm.bedType },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }